// extracted by mini-css-extract-plugin
module.exports = {"dotBase":"Dot_dotBase__2OfAi","dotLarge":"Dot_dotLarge__3jugs"};